/**
 * LES SCHÉMAS DE L'ATELIER DE FIGURES, PALIER L5 — ce qu'un auteur écrit pour
 * qu'un exercice se MANIPULE (`docs/pilotage/atelier-figures/CONCEPTION.md`
 * § 2, F7, F9, F11). Tous ADDITIFS : un exercice qui ne les écrit pas est lu
 * comme avant.
 *
 *  - `experience` (à côté de l'énoncé) : une expérience aléatoire à simuler (F11) ;
 *  - `reponse.droite` (diagramme `nuage`) : une droite à tracer à l'œil, sa
 *    méthode et sa bande (F7) ;
 *  - `reponse.aimant` (bandes, ligne brisée, histogramme, nuage) : le pas d'une
 *    barre ou d'un point qu'on glisse (F7) ;
 *  - `reponse.graphe` (diagramme `graphe`) : ce qu'on fait du graphe (F9).
 *
 * La forme seulement : ce qu'un schéma ne voit pas (des probabilités qui
 * somment à 1, un graphe qui a une chaîne eulérienne) est dans
 * `griefsDExperience`, `griefsDeDroiteALOeil`, `griefsDeTacheDeGraphe`, que
 * l'import appelle.
 */
import { z } from 'zod';
import { METHODES_D_AJUSTEMENT } from '../fiches/ajustement.js';
import { ECRITURES_DE_FREQUENCE, GENRES_D_EXPERIENCE, ISSUES_D_EXPERIENCE, } from '../fiches/simulation.js';
const probabilite = z
    .string()
    .trim()
    .regex(/^\d+(?:[.,]\d+)?(?:\/\d+)?$/, 'une probabilité s’écrit « 1/4 », « 1 » ou « 0,25 »');
const nomDIssue = z.string().trim().min(1).max(16);
export const experienceSchema = z
    .object({
    genre: z.enum(GENRES_D_EXPERIENCE),
    decrit: z.string().trim().min(20).max(600),
    issues: z
        .array(z.object({ nom: nomDIssue, p: probabilite }).strict())
        .min(ISSUES_D_EXPERIENCE.min)
        .max(ISSUES_D_EXPERIENCE.max),
    evenement: z
        .object({
        nom: z.string().trim().min(1).max(60),
        issues: z.array(nomDIssue).min(1),
    })
        .strict()
        .optional(),
    frequences: z.enum(ECRITURES_DE_FREQUENCE).optional(),
    probabiliteMontree: z.boolean().optional(),
})
    .strict();
export const droiteALOeilSchema = z
    .object({
    methode: z.enum(METHODES_D_AJUSTEMENT),
    bande: z.number().positive().finite(),
    pointMoyen: z.number().positive().finite().optional(),
})
    .strict();
const nomDeSommet = z.string().trim().min(1).max(6);
export const tacheDeGrapheSchema = z.discriminatedUnion('tache', [
    z
        .object({
        tache: z.literal('construire'),
        aretesDonnees: z.array(z.number().int().min(0)).optional(),
        sommetsAAjouter: z.array(nomDeSommet).optional(),
    })
        .strict(),
    z.object({ tache: z.literal('chaine_eulerienne'), cycle: z.boolean().optional() }).strict(),
    z.object({ tache: z.literal('plus_courte_chaine'), de: nomDeSommet, a: nomDeSommet }).strict(),
    z
        .object({ tache: z.literal('coloration'), couleurs: z.number().int().min(1).max(6).optional() })
        .strict(),
    z.object({ tache: z.literal('arbre_couvrant'), minimal: z.boolean().optional() }).strict(),
]);
/** Le pas d'une barre ou d'un point qu'on glisse. */
export const aimantSchema = z.number().positive().finite();
//# sourceMappingURL=manipulation.schema.js.map